import { useState } from "react";

/*
 * Collapsible block used in the sales document forms (devis, BDC, facture) to
 * keep rarely used fields out of the way. Closed by default.
 */
const OptionalSection = ({ title, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border rounded mb-3">
      <button
        type="button"
        className="btn btn-link btn-block text-left text-dark d-flex justify-content-between align-items-center"
        style={{ textDecoration: "none", fontWeight: 600 }}
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span>
          <i className="fas fa-sliders-h mr-2"></i>
          {title} <small className="text-muted">(facultatif)</small>
        </span>
        <i className={`fas fa-angle-${open ? "up" : "down"}`}></i>
      </button>
      <div className="px-3 pt-2" style={{ display: open ? "block" : "none" }}>
        {children}
      </div>
    </div>
  );
};

export default OptionalSection;
